<template>
    <div :id="id" class="count-bar flex-y-center span">
        <div class="bar counted"></div>
        <div class="bar uncounted"></div>
    </div>
</template>

<script>
import $ from "jquery";
import { Animation } from "@/assets/JS/Animation.js";
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "ProjectDetailTypesCountBar",
    props: {
        id: String,
        count: Number,
        contentInitiated: Boolean
    },
    mounted: function() {

        // Animate bars in
        const $instance = $(`#${this.id}`);
        const countedWidth = this.count * 5;
        const uncountedWidth = 100 - countedWidth;
        const $barCounted = $instance.find(".counted");
        const $barUncounted = $instance.find(".uncounted");
        const duration = !this.contentInitiated
            ? CONFIG.projects.detailContentAnimationSpeed
            : 0;
        new Animation($barCounted, "Width", `${countedWidth}%`, duration, 0);
        new Animation($barUncounted, "Width", `${uncountedWidth}%`, duration, 0);

    }
};
</script>